
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt-pools",
      function () {
        return require("private-next-pages/lt-pools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt-pools"])
      });
    }
  